import { Injectable, Inject } from '@angular/core';
import { Headers, Http, URLSearchParams } from '@angular/http'
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import {LocalstorageService} from './localstorage.service';
import { HttpParameterCodec, HttpParams, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class ApiService {
   url:any;
   private API_URL = environment.apiUrl;
  constructor(
    @Inject(Http)
    private http: Http,
    private localstorage:LocalstorageService
  ) {}

   
  private setHeaders(isAuthorize:boolean,isContentAllowed:boolean=true): Headers {
       
    var accessToken = this.localstorage.getToken();
    //var API_URL= this.API_URL;

    
    const headersConfig = {
      
      'Accept': 'application/json',
    };

    if(isContentAllowed){
      headersConfig["Content-Type"]="application/json";
    }
    if(isAuthorize){
      if (accessToken) {
        headersConfig['Authorization'] = accessToken;      
      }       
    }
    
  
    return new Headers(headersConfig);
  }

  
  setFileUploadHeaders(): HttpHeaders {
    var token = localStorage.getItem("loginToken");
    const headersConfig = {
    }
    if (token != null || token != undefined) {
      headersConfig['Authorization'] = token;

    }
    return new HttpHeaders(headersConfig);
  }
  
  get(path: string, params: URLSearchParams = new URLSearchParams(),isAuthorize:boolean=true): Observable<any> {
    return this.http.get(`${this.API_URL}${path}`, { headers: this.setHeaders(isAuthorize), search: params });
  }
  

  post(path: string, body: Object = {},isAuthorize:boolean=true): Observable<any> {
    
    return this.http.post(`${this.API_URL}${path}`,JSON.stringify(body), { headers: this.setHeaders(isAuthorize) });
  }
  

  put(path: string, body: object = {},isAuthorize:boolean=true): Observable<any> {
    return this.http.put(`${this.API_URL}${path}`, JSON.stringify(body), { headers: this.setHeaders(isAuthorize) });
  }

  delete(path: string, isAuthorize:boolean=true,isContentAllowed:boolean=true): Observable<any> {
    return this.http.delete(`${this.API_URL}${path}`, { headers: this.setHeaders(isAuthorize, isContentAllowed) });
  } 
}